import React from 'react'
import DoneIcon from '@material-ui/icons/Done'
import Typography from '@material-ui/core/Typography'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
  },
  icon: {
    width: 32,
    height: 32,
    marginRight: 8,
    color: '#8EBE94',
  },
  message: {
    fontWeight: theme.typography.fontWeightBold,
    fontSize: theme.typography.pxToRem(16),
  },
}))

export default function Success({ children }) {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <DoneIcon className={classes.icon} />
      <Typography className={classes.message}>{children}</Typography>
    </div>
  )
}
